import React from "react";
import {css, cx} from "@emotion/css";

// utils
import {IProps} from "utils/types/html";
import {Theme} from "utils/types/theme";
import {useTheme} from "utils/theme";

// atoms
import {Typography} from "ui/atoms/Typography";

// molecules
import {Logo} from "ui/molecules/Logo";

// templates
import {TesterSingleTemplate} from "ui/templates/TesterSingle";

export interface Props extends IProps<HTMLDivElement> {
  continue: string;
  welcome: string;
  continueClick(): void;
}

export const TestWelcome: React.FC<Props> = (props) => {
  const theme = useTheme();

  return (
    <TesterSingleTemplate
      {...props}
      className={cx(props.className, styles(props, theme), "test-welcome")}
    >
      {/* <Logo logoColor={theme.colors.Primary.Crimson} /> */}
      <Typography testId={props.testId + "-welcometext"} variant="headline6">
        {props.welcome}
      </Typography>
    </TesterSingleTemplate>
  );
};

// css design
const styles = (props: Props, theme: Theme) => css``;
